

import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Card, CardBody, Col, Container, Nav, NavItem, NavLink, Row, Spinner } from 'reactstrap';
import BreadCrumb from '../../Components/Common/BreadCrumb';
import classnames from "classnames";
import axios from 'axios';
// import RenderRazorpay from './RenderRazorPay';
import { useSelector, useDispatch } from "react-redux";
import { toast } from 'react-toastify';
import { profiledata } from '../../../src/slices/thunks';
import { useNavigate } from 'react-router-dom';
import { OrderAPI } from '../../helpers/firebase_helper';


const Pricing = () => {
    const [activeTab, setActiveTab] = useState('1');
    const [selectedPlan, setSelectedPlan] = useState(null); // To track selected plan
    const [currentPrice, setCurrentPrice] = useState(0); // State for current price
    const [pricingData, setPricingData] = useState([]);
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(false);
    const [loadingButtonId, setLoadingButtonId] = useState(null);
    const profileData = useSelector((state) => state.Profile.profileData);
    const dispatch = useDispatch();
    const navigate = useNavigate();

    useEffect(() => {

        if (selectedPlan) {
            // console.log("freuency", selectedPlan.period);
            const price = activeTab === '1' ? selectedPlan.amount : selectedPlan.amount;
            setCurrentPrice(price);
        }
    }, [activeTab, selectedPlan]);

    const toggleTab = (tab) => {
        if (tab !== activeTab) {
            setActiveTab(tab);
        }
    };
    const [cognito_id, setCognitoId] = useState(null);



    useEffect(() => {

        const result = profileData?.result?.cognito_id; 
        const result1 = profileData?.result?.current_plan?.plan_name;
        const result2 = profileData?.result?.current_plan;
        const frequency = profileData?.result?.billing_frequency;

        setCognitoId(result); 
        const fetchPricingData = async () => {

            setLoading(true);
            try {
                const response = await OrderAPI.getPlans();
                
                const transformedData = response.result.map((plan, index) => ({
                    id: plan.plan_id,
                    type: plan.plan_name,
                    amount: plan.plan_amount,
                    features: plan.features,
                    status: plan.status,
                    period: plan.period,
                    planButtonClassname: ((plan.plan_name == result1 || plan.plan_name == result2) && plan.period == frequency ) ? "success" : "danger",
                    // btnstatus: (plan.plan_name == result1 || plan.plan_name == result2 && plan.period == frequency) ? " disabled " : "", 
                    btntxt: ((plan.plan_name == result1 || plan.plan_name == result2) && plan.period == frequency) ? "Extend Plan" : "Upgrade Plan",
                }));
                setPricingData(transformedData);

            } catch (error) {
                setError(error.message);

            } finally {
                setLoading(false);
            }
        };

        fetchPricingData();

    }, [profileData]);



    // Filter plans based on activeTab (Monthly or Annually)
    const filteredPlans = pricingData.filter(plan => {
        return activeTab === '1' ? plan.period === 'monthly' : plan.period === 'yearly';
    });
    
    const currentPaidPlan = pricingData.find(plan => plan.type === profileData?.result?.current_plan && plan.period === profileData?.result?.billing_frequency);
  

    const handleCreateOrder = (plan) => {
       
        // console.log("plan created", plan);
        if (plan.type === "Basic"){
            alert("Your plan will automatically switch to the Basic plan after your current subscription ends unless you upgrade to a paid plan.")
        }
        else{
            navigate('/billing/billing-address',  { state: { selectedPlan:plan, currentPaidPlan } });  // Change the path to your Billing Address page
        }
    };


   

    document.title = "Media Engine | Billing";


    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                    <BreadCrumb title="Current Plans" pageTitle="Billing" />
                    <Row className="justify-content-center mt-4">
                        <Col lg={5}>
                            <div className="text-center mb-4">
                                <h4 className="fs-22">Choose the plan that's right for you</h4>
                                <p className="text-muted mb-4 fs-15">Simple pricing. No hidden fees. Advanced features for you business.</p>

                                <div className="d-inline-flex">
                                    <Nav className="nav-pills arrow-navtabs plan-nav rounded mb-3 p-1" id="pills-tab" role="tablist">
                                        <NavItem>
                                            <NavLink
                                                href="#"
                                                className={classnames({ active: activeTab === '1' }, 'fw-semibold')}
                                                onClick={() => { toggleTab('1'); }}
                                            >
                                                Monthly
                                            </NavLink>
                                        </NavItem>
                                        <NavItem>
                                            <NavLink
                                                href="#"
                                                className={classnames({ active: activeTab === '2' }, 'fw-semibold')}
                                                onClick={() => { toggleTab('2'); }}
                                            >Annually <span className="badge bg-success">25% Off</span>
                                            </NavLink>
                                        </NavItem>
                                    </Nav>
                                </div>
                            </div>
                        </Col>
                    </Row>


                    <Row className="justify-content-center">
                        {loading ? (
                            <div className="text-center">
                                <Spinner color="primary" />
                                <p>Loading plans ...</p>
                            </div>
                        ) : (
                            filteredPlans.map((plan, key) => (
                                <Col lg={4} key={key}>
                                    <Card className={`pricing-box ribbon-box right`}>
                                        <CardBody className="m-2 p-4">
                                            <div className="d-flex align-items-center mb-3">
                                                <div className="flex-grow-1">
                                                    <h5 className="mb-0 fw-semibold">{plan.type}</h5>
                                                    {/* <p>Status: {plan.status}</p> */}
                                                </div>
                                                <div className="ms-auto">
                                                    <h2 className="month mb-0">${plan.amount} <small className="fs-13 text-muted">/Month</small></h2>
                                                </div>
                                            </div>
                                            <ul className="list-unstyled vstack gap-3">
                                                {/* <li><b>Storage:</b> {plan.features.Storeage_DTO}</li> */}
                                                <li><b>Max Video Length:</b> {plan.features.Max_Video_Length}</li>
                                                <li><b>Max Video Size:</b> {plan.features.Max_Video_Size}</li>
                                                <li><b>Users:</b> {plan.features.Users}</li>
                                                <li><b>Bandwidth:</b> {plan.features.Bandwidth}</li>
                                                <li><b>Storage:</b> {plan.features.Storage_DTO}</li>
                                                <li><b>Email Support:</b> {plan.features.Email_Support}</li>
                                                <li><b>Thumbnail Generation:</b> {plan.features.Thumbnail_Generation ? "Yes" : "No"}</li>
                                                <li><b>Analytics:</b> {plan.features.Analytics}</li>
                                                <li><b>Chat Support:</b> {plan.features.Chat_Support}</li>
                                                <li><b>Geo Restrictions:</b> {plan.features.Geo_Restrictions ? "Yes" : "No"}</li>
                                            </ul>

                                            <div className="mt-3 pt-2">
                                                <button
                                                    className={`btn btn-${plan.planButtonClassname} w-100 ${plan.btnstatus} `}
                                                    onClick={() => handleCreateOrder(plan)}
                                                >
                                                    {loadingButtonId === plan.id ? (
                                                        <Spinner size="sm" className='me-2' /> // Display spinner when loading
                                                    ) : (
                                                        `${plan.btntxt}`
                                                    )}
                                                </button>
                                            </div>
                                        </CardBody>
                                    </Card>
                                </Col>
                            ))
                        )}
                    </Row>

                   
                </Container>
            </div>
        </React.Fragment>
    );
};

export default Pricing;
